import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { SecondaryButton } from '@bibliocommons/base-buttons';

export default function CancelHoldButton({ handleClick, isLoading, disabled }) {
  return (
    <SecondaryButton
      className="cp-cancel-hold-button"
      isLoading={isLoading}
      disabled={disabled}
      handleClick={handleClick}>
      <FormattedMessage id="cancel_hold" />
    </SecondaryButton>
  );
}

CancelHoldButton.propTypes = {
  handleClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/CancelHoldButton/CancelHoldButton.jsx